const LoadingSpinner: React.FC = () => (
  <div className="spinner-border" role="status">
    <span className="sr-only">Loading...</span>
  </div>
);

export default LoadingSpinner;
